<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.jyjj" alt>
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">Machines Group of Extrusion Press</span>
          </u>
        </b>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:Arial;"></span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp;</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">This series of equipment is suitable for extruding copper, aluminum and its alloys, pipes, rods, bars, wires and other products.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p style="margin-left:0cm;text-indent:0cm;">
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <span>
            1、
            <span>&nbsp;</span>
          </span>
        </span>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#333333;"
        >The structure of the whole machine adopts a four-column horizontal type with an oil tank on the top. It has the features of new structure, neat arrangement and convenient maintenance.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>2、
        </span>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#333333;"
        >The movable beam adopts four-point positioning and the center can be adjusted. The reasonable tooling design can greatly reduce the production cost.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>3
        </span>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#333333;"
        >、Different extrusion processes can be set, and follow-up and fixed needle methods are used to extrude pipes with different apertures.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>4
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">、The hydraulic parts use a large flow cartridge valve system, which has good sealing performance and low temperature rise.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">
          <br>5
        </span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">、The electrical components use the most advanced</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">PLC</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#333333;">products, which is reliable and sensitive.</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;color:#333333;">&nbsp;</span>
      </p>
      <div align="center">
        <table
          style="width:100.0%;background:#E8E8E8;"
          class="ke-zeroborder"
          border="0"
          cellpadding="0"
          cellspacing="1"
          width="100%"
        >
          <tbody>
            <tr>
              <td style="background:white;" valign="top">
                <p style="text-align:left;text-indent:138.7pt;" align="left">
                  <b>
                    <span style="font-size:9.0pt;font-family:宋体;"></span>
                  </b>
                  <b>
                    <span
                      style="font-size:9.0pt;font-family:Verdana;color:#999999;"
                    >Technical parameters</span>
                  </b>
                  <span style="font-size:9.0pt;font-family:Verdana;"></span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p style="text-align:left;background:white;" align="left">
        <span style="font-size:9.0pt;font-family:Verdana;color:#333333;">&nbsp;</span>
      </p>
      <table
        style="width:100.0%;border-collapse:collapse;"
        class="ke-zeroborder"
        border="0"
        cellpadding="0"
        cellspacing="0"
        width="100%"
      >
        <tbody>
          <tr>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:宋体;">Equipment Model</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:宋体;">Rated System Pressure</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:宋体;">Rated Extrusion Force</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:宋体;">Main Engine Center Height</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:宋体;">Extrusion Barrel Size Range</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:宋体;">Main Motor Power</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">300</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">21Mpa</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">3000KN</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">700mm</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">Φ55-Φ75×350</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">110kw</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">500</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">21Mpa</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">5000KN</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">895mm</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">Φ75-Φ95×400</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">150kw</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">630</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">21Mpa</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">6300KN</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">945mm</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">Φ85-Φ105×500</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">225kw</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">800</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">21Mpa</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">8000KN</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1045mm</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">Φ105-Φ135×550</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">396kw</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1000</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">21Mpa</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">10000KN</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1095mm</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">Φ125-Φ145×600</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">396kw</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1250</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">21Mpa</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">12500KN</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1185mm</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">Φ135-Φ165×650</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">528kw</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1630</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">21Mpa</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">16300KN</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1285mm</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">Φ155-Φ205×750</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1000kw</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1800</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">21Mpa</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">18000KN</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1285mm</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">Φ175-Φ225×800</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1000kw</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">2000</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">21Mpa</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">20000KN</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1650mm</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">Φ195-Φ245×850</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1075kw</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">2500</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">21Mpa</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">25000KN</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1700mm</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">Φ225-Φ265×900</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1250kw</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">3000</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">21Mpa</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">30000KN</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1860mm</span>
                <span style="font-size:9.0pt;font-family:Verdana;"></span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">Φ255-Φ305×1000</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">1500kw</span>
              </p>
            </td>
            <td style="border:solid gray 1.0pt;">
              <p style="text-align:center;" align="center">
                <span style="font-size:9.0pt;font-family:Verdana;">&nbsp;</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        <span style="font-family:宋体;">
          <br>
        </span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        jyjj: require("../../../assets/img/common/jyjj.jpg")
      }
    };
  },

  components: {},
  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/device/jyjj.vue